// utils/fotosDeProducto.js — P3-1 (punto 5). Piezas PURAS del flujo «subir
// todas las fotos del producto una vez y después, por variación, ELEGIR cuál»:
//  - la lista de la pestaña «Fotos de este producto» del diálogo de imagen de
//    una variación (principal + galería + ya asignadas a otras variaciones);
//  - el reparto cuando se SUBEN varias fotos desde el diálogo de una variación:
//    la primera queda en la variación y el resto va a la galería — antes se
//    DESCARTABAN en silencio (ProductPage list[0], medido en la Fase A).
// Las fija fotosDeProducto.test.js por mutación.

// form.images = [{ id, src, alt }]; variations = crudo del GET (v.image).
export function fotosDelProductoParaSelector(formImages, variations) {
  const vistas = new Set();
  const out = [];
  (formImages || []).forEach((img, i) => {
    if (!img || img.id == null || vistas.has(img.id)) return;
    vistas.add(img.id);
    out.push({ id: img.id, src: img.src, alt: img.alt || '', etiqueta: i === 0 ? 'Principal' : 'Galería' });
  });
  (variations || []).forEach((v) => {
    const img = v && v.image;
    if (!img || img.id == null || vistas.has(img.id)) return;
    vistas.add(img.id);
    const opts = ((v.attributes || []).map((a) => a.option).filter(Boolean)).join(' / ');
    out.push({ id: img.id, src: img.src, alt: img.alt || '', etiqueta: opts || `Variación ${v.id}` });
  });
  return out;
}

// Varias fotos entregadas al diálogo de UNA variación: una para la variación,
// el resto a la galería (nunca descartar en silencio).
export function repartirFotosParaVariacion(list) {
  const fotos = (list || []).filter(Boolean);
  return { paraVariacion: fotos[0] || null, paraGaleria: fotos.slice(1) };
}
